import { useTranslation } from "react-i18next";
import { Form, Input, Textarea } from "@renderbus/ui";
import { FormInstance } from "antd";
import { IExportData } from "@/pages/export-list/types";
import styled from "styled-components";
import PaySuccessIcon from "@/assets/icons/topup/paysuccess";

export function AppealForm({
  appealForm,
  isSubmitAppealForm,
  billInfo,
  onOpenProgress,
}: {
  appealForm: FormInstance;
  isSubmitAppealForm: boolean;
  onOpenProgress: () => void;
  billInfo?: IExportData;
}) {
  const { t } = useTranslation("center");
  return isSubmitAppealForm ? (
    <BillingAppealSubmitSuccess>
      <PaySuccessIcon />
      <BillingAppealTitle>
        {t("consume_appeal_submit_success")}
      </BillingAppealTitle>
      <BillingAppealSubTitle>
        {t("consume_appeal_wait_tip")}
        <span onClick={onOpenProgress}>{t("consume_appeal_progress")}</span>
      </BillingAppealSubTitle>
    </BillingAppealSubmitSuccess>
  ) : (
    <Form
      form={appealForm}
      colon={false}
      layout="vertical"
      className="renderbus-ui--form appeal-form"
      size="middle"
    >
      <Form.Item label={t("consumption_time_selector")} name="billCycle">
        {billInfo?.consumeDate}
      </Form.Item>
      <Form.Item label={t("consumption_label_bill_no")} name="billNo">
        {billInfo?.billNo}
      </Form.Item>
      <Form.Item
        label={t("consumption_user_id")}
        name="userId"
        rules={[{ required: true }]}
      >
        <Input
          disabled
          placeholder={t("consumption_user_id_placeholder")}
          className="background-2C2C31"
        />
      </Form.Item>
      <Form.Item
        label={t("user_operate_record_user_name")}
        name={"userName"}
        rules={[{ required: true }]}
      >
        <Input className="background-2C2C31" disabled />
      </Form.Item>
      <Form.Item
        label={t("bill_table_column_connect")}
        name={"connectInformation"}
      >
        <Input className="background-2C2C31" disabled />
      </Form.Item>
      <Form.Item
        label={t("consumption_bill_appeal_content")}
        name="appealContent"
        rules={[
          {
            validator: (a, b) => {
              if (!b.trim())
                return Promise.reject(
                  t("consumption_bill_appeal_content_placeholder")
                );
              return Promise.resolve();
            },
            validateTrigger: "onBlur",
          },
          {
            required: true,
            message: t(
              "consumption_bill_appeal_content_placeholder"
            ).toString(),
          },
        ]}
      >
        <Textarea
          className="background-2C2C31 appeal-textarea"
          maxLength={50}
        />
      </Form.Item>
    </Form>
  );
}

const BillingAppealSubmitSuccess = styled.div`
  text-align: center;
  margin-top: 164px;
`;

const BillingAppealTitle = styled.div`
  font-weight: 600;
  font-size: 20px;
  line-height: 28px;
  color: #edf2f5;
  padding-top: 16px;
`;
const BillingAppealSubTitle = styled.div`
  padding-top: 30px;
  font-size: 16px;
  line-height: 22px;
  color: #d4d4d4;
  span {
    color: var(--main-color);
    cursor: pointer;
    margin-left: 6px;
  }
`;
